import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { destroy } from '../../api';
import UserContext from '../../contexts/User';

import FrameSectionHeader from '../../components/FrameSectionHeader';
import FrameHeader from '../../components/FrameHeader';
import Frame from '../../components/Frame';
import DeleteConfirmation from '../../components/DeleteConfirmation';

// import styles from './UserSettings.module.scss';

export default function Usersettings({ match: { params } }) {
  const [redirect, setRedirect] = useState(false);
  const { user } = useContext(UserContext);

  const deleteUser = async () => {
    await destroy(`/users/${params.id}`);
    setRedirect(`/users`);
  };

  return redirect ? (
    <Redirect to={redirect} />
  ) : (
    <>
      <FrameHeader title="Settings" />
      <Frame>
        <FrameSectionHeader icon="delete" title="Delete" />
        <DeleteConfirmation
          challenge={`${user.first_name} ${user.last_name}`}
          name="User"
          onDelete={deleteUser}
        />
      </Frame>
    </>
  );
}
